;
define("requestquote_wizard_module_items_line_quantity.tpl", function(){});

